import { TabContext } from "@mui/lab";
import {
  Checkbox,
  Grid2,
  IconButton,
  MenuItem,
  Tab,
  TableCell,
  Typography,
} from "@mui/material";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import React, { Fragment, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BackArrowIco from "../../../assets/icons/BackArrowIco";
import CandidateSourcingDownloadIco from "../../../assets/icons/CandidateSourcingDownloadIco";
import CandidateWarningIco from "../../../assets/icons/CandidateWarningIco";
import ChatBotInputIco from "../../../assets/icons/ChatBotInputIco";
import EyeIco from "../../../assets/icons/EyeIco";
import Breadcrumbs from "../../../component/Breadcrumbs";
import CommonButton from "../../../component/Button";
import CommonTextField from "../../../component/Input";
import SnackBar from "../../../component/SnackBar";
import {
  JobCandidateSourcing,
  ScoringCandidate,
} from "../../../redux/action/Job";
import { buildUrl, HandleSkeletion } from "../../../utils/constants";
import { CustomDiv } from "../../chat-bot/style";
import {
  CommonGrid2,
  CustomTooltip,
  DotColor,
  ScoreChange,
  StatusChange,
  TabViewSection,
} from "../../common-components/StyledComponents";
import CandidateResult from "./components/CandidateResult";
import CandidateProgress from "./components/CandidateProgress";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  AddToJobPool,
  SeachExternalDataBaseRowClick,
} from "../../../redux/action/Candidate";
import { CustomizeTableCell } from "../style";
import { UploadJob } from "../../../redux/action/QuickMatch";
import JobStarOnlyIco from "../../../assets/icons/JobStarOnlyIco";
import JobStarIco from "../../../assets/icons/JobStarIco";
import DialogCandidateHub from "../candidate-scoring/components/DialogCandidateHub";

export default function CandidateScoring() {
  const tabData = ["Standard", "Deep Search"];
  const [tabValue, setTabValue] = useState(0);
  const navigate = useNavigate();
  const query = new URLSearchParams(useLocation().search);
  const jobId = query.get("id");
  const getBreadcrumb = query.get("breadcrumbs");

  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [externalValidating, setExternalValidating] = useState(false);
  const dispatch = useDispatch();
  const candidateSourcing = useSelector(
    (state) => state.jobs.jobCandidateSourcing,
  );
  const processConditionCheck =
    candidateSourcing[jobId] &&
    candidateSourcing[jobId].data.length !== 0 &&
    candidateSourcing[jobId].status !== "process";
  const processConditionCheckInprogress =
    candidateSourcing[jobId] &&
    candidateSourcing[jobId].data.length !== 0 &&
    candidateSourcing[jobId].status === "Inprogress";
  const [checkSelected, setCheckSelected] = useState({
    candidateSelect: [],
    externalSelect: [],
  });
const [statusDialog, setSelectDialog] = useState({
  open: false,
  disabled: false,
  changeStatusLoading: false,
  cancelLoading: false,
  changeLoading: false,
  value: "Active",
  id: "",
  condition: true,
  allInvalid: false, 
});

const handleChangeStatusClose = () => {
  setSelectDialog({
    open: false,
    disabled: false,
    changeStatusLoading: false,
    cancelLoading: false,
    changeLoading: false,
    value: "Active",
    id: "",
    condition: true,
    allInvalid: false,
  });

  
  setCheckSelected({
    candidateSelect: [],
    externalSelect: [],
  });
};
  const [pendingValidResumes, setPendingValidResumes] = useState([]);
  const [dialogErrorMessage, setDialogErrorMessage] = useState("");
  

  const [resultData, setResultData] = useState({
    loading: true,
    company_name: "",
    titles: [],
    searhLoading: false,
    data: [
      {
        title: "Candidate Hub Results",
        // sort: true,
        sort_data: [
          { name: "Relevancy Score", value: "score_only" },
          { name: "Creation Date", value: "created_at_only" },
        ],
        sort_data_value: {},
        header: [
          { name: "Select", direction: "asc", sort: false },
          { name: "Id", direction: "asc", sort: false },
          { name: "Name", direction: "asc", sort: false },
          { name: "Relevancy", direction: "asc", sort: false },
          { name: "Match Criteria", direction: "asc", sort: false },
          { name: "Status", direction: "asc", sort: false },
          { name: "Action", direction: "asc", sort: false },
          { name: "Created", direction: "asc", sort: false },
          { name: "View", direction: "asc", sort: false },
        ],
        withPagination: false,
        details: "See More",
        data: [],
        totalPage: 0,
        currentPage: 1,
      },
      {
        title: "External Search Results",
        header: [
          { name: "Select", direction: "asc", sort: false },
          { name: "Name", direction: "asc", sort: false },
          { name: "Source", direction: "asc", sort: false },
          { name: "Relevancy", direction: "asc", sort: false },
          { name: "Match Criteria", direction: "asc", sort: false },
          { name: "Action", direction: "asc", sort: false },
          {
            name: "Download",
            direction: "asc",
            sort: false,
            textAlign: "center",
          },
        ],
        withPagination: false,
        details: "See More",
        data: [],
        button: "Add to External Search",
      },
    ],
  });

  const handleBackClick = () => {
    if (getBreadcrumb === "job") {
      navigate("/jobs");
    } else navigate(buildUrl("/jobs/jobs-view", {}, getBreadcrumb));
  };

  const breadCrumbData = [
    ...(getBreadcrumb && getBreadcrumb === "job"
      ? [
          {
            title: "Jobs",
            navigate: `/jobs`,
          },
          {
            title: "Candidate Sourcing",
            active: true,
          },
        ]
      : [
          ...(getBreadcrumb &&
          getBreadcrumb !== "null" &&
          getBreadcrumb !== "undefined"
            ? [
                {
                  title: "Work Flow",
                  navigate: `/job-krystal-path`,
                },
              ]
            : [
                {
                  title: "Jobs",
                  navigate: `/jobs`,
                },
              ]),
          {
            title: query.get("title"),
            navigate: buildUrl("/jobs/jobs-view", {}, getBreadcrumb),
          },
          {
            title: "Candidate Sourcing",
            active: true,
          },
        ]),
  ];

  const handleFetchCall = async ({
    jobId,
    page = resultData?.data?.[0]?.currentPage,
    sort_mode = resultData?.data?.[0]?.sort_data_value?.value,
  }) => {
    setResultData((prev) => {
      return {
        ...prev,
        loading: true,
        data: prev.data.map((item, index) => {
          return {
            ...item,
          };
        }),
      };
    });
    try {
      let params = {
        sort_mode: sort_mode,
        page: page,
        page_size: 10,
      };
      let data = await ScoringCandidate(jobId, params);
      setResultData((prev) => {
        return {
          ...prev,
          company_name: data?.data?.company_name,
          titles: data?.data?.titles || [],
          loading: false,
          data:
            prev.data.map((item, index) => {
              if (index === 0) {
                return {
                  ...prev.data[index],
                  data: data?.data?.chub_resumes,
                };
              } else {
                return {
                  ...prev.data[index],
                  data: data?.data?.l3_resumes,
                };
              }
            }) || [],
        };
      });
    } catch (error) {
      setResultData((prev) => {
        return {
          ...prev,
          loading: false,
          data:
            prev.data.map((item, index) => {
              return {
                ...item,
              };
            }) || [],
        };
      });
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  useEffect(() => {
    handleFetchCall({ jobId });
    if (processConditionCheckInprogress) {
      setSnackbarState({
        open: true,
        message:
          "A background process is in progress. Please wait a few minutes while it completes.",
        severity: "note",
      });
    }
  }, []);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleViewClick = (row) => {
    navigate(`/candidates/candidate-view?view-id=${row.id}`);
  };

  const handleCheckRow = (row) => {
    const existing =
      JSON.parse(localStorage.getItem("Candidate Sourcing")) || {};
    setCheckSelected((prev) => {
      const selected = prev.candidateSelect.some((item) => item.id === row.id);
      let newSelected;

      if (selected) {
        newSelected = prev.candidateSelect.filter((item) => item.id !== row.id);
      } else {
        const { match_criteria_normal, match_criteria_deep, ...safeRow } = row;
        newSelected = [...prev.candidateSelect, safeRow];
      }

      const checkData = newSelected.map((item) => ({
        ...item,
        file: {
          progress: 1,
          buffer: 1,
          visible: false,
        },
      }));
      const updated = {
        ...existing,
        [jobId]: {
          ...existing[jobId],
          data: checkData,
          status: "process",
        },
      };
      localStorage.setItem("Candidate Sourcing", JSON.stringify(updated));
      dispatch(
        JobCandidateSourcing({
          id: jobId,
          data: updated[jobId].data,
          status: "process",
        }),
      );
      return { ...prev, candidateSelect: newSelected };
    });
  };

  const handleHubTableBodyData = (row) => {
    return (
      <>
        <TableCell>
          <Checkbox
            color="primary"
            checked={checkSelected.candidateSelect.some(
              (item) => item.id === row.id,
            )}
            onChange={() => handleCheckRow(row)}
            disabled={processConditionCheckInprogress || row.is_added_to_job}
          />
        </TableCell>
        <TableCell>{row.order_no || "-"}</TableCell>
        <TableCell>{row.name || "-"}</TableCell>
        <TableCell>
          <ScoreChange>{row.relevancy_score}%</ScoreChange>
        </TableCell>
        <TableCell>
          <CommonGrid2 display={"flex"} gap={"10px"} flexWrap={"wrap"}>
            {(row.match_criteria_normal &&
              row.match_criteria_normal.map((item, index) => {
                console.log(item, "item");
                return (
                  <CustomDiv
                    border="1px solid #D0D5DD"
                    padding="2px"
                    borderRadius="5px"
                    fontSize="10px"
                    background="#F9F5FF"
                  >
                    <Typography
                      textTransform="capitalize"
                      fontSize="13px"
                      display="flex"
                      alignItems="center"
                      gap="5px"
                    >
                      {item.name}

                      {item.name === "title" && item.is_inferred_title && (
                        <CustomTooltip
                          title={
                            <Typography
                              fontSize="13px"
                              display="flex"
                              alignItems="center"
                              gap="4px"
                              fontWeight="500"
                            >
                              <JobStarOnlyIco fill="white" /> Inferred
                            </Typography>
                          }
                          placement="top"
                          backgroundColor="#0070F2"
                          borderRadius="50px"
                        >
                          <Typography
                            component="span"
                            display="flex"
                            alignItems="center"
                            sx={{ cursor: "pointer" }}
                          >
                            <JobStarIco />
                          </Typography>
                        </CustomTooltip>
                      )}
                    </Typography>
                  </CustomDiv>
                );
              })) ||
              "-"}
          </CommonGrid2>
        </TableCell>
        <TableCell>
          <StatusChange>
            <DotColor
              color={
                row.status === "Active"
                  ? "green"
                  : row.status === "Hold"
                    ? "orange"
                    : "#667085"
              }
            />
            {row.status || "-"}
          </StatusChange>
        </TableCell>
        <TableCell>
          {row.is_added_to_job ? (
            <CommonGrid2 display={"flex"} gap={"10px"}>
              <TaskAltIcon sx={{ color: "#17B26A", fontSize: "20px" }} />
              <Typography variant="body2" color="#17B26A">
                Added to Job
              </Typography>
            </CommonGrid2>
          ) : (
            "-"
          )}
        </TableCell>
        <TableCell>
          {row.created_at
            ? new Date(row.created_at).toLocaleDateString("en-US", {
                month: "long",
                day: "numeric",
                year: "numeric",
              })
            : "-"}
        </TableCell>{" "}
        <TableCell>
          <IconButton onClick={() => handleViewClick(row)}>
            <EyeIco />
          </IconButton>
        </TableCell>
      </>
    );
  };

  const handleSearchTableBodyData = (row) => {
    return (
      <>
        <TableCell>
          <Checkbox
            color="primary"
            checked={checkSelected.externalSelect.some(
              (item) => item.ResumeID === row.ResumeID,
            )}
            disabled={processConditionCheckInprogress || row.is_added_to_job}
            onChange={() => handleCheckExternalRow(row)}
          />
        </TableCell>
        <TableCell>{row.name || "-"}</TableCell>
        <TableCell>{row.source || "-"}</TableCell>
        <TableCell>
          <ScoreChange>{row.relevancy}</ScoreChange>
        </TableCell>
        <TableCell>{row.match || "-"}</TableCell>
        <TableCell>
          {row.is_added_to_job ? (
            <CommonGrid2 display={"flex"} gap={"10px"}>
              <TaskAltIcon sx={{ color: "#17B26A", fontSize: "20px" }} />
              <Typography variant="body2" color="#17B26A">
                Added to Job
              </Typography>
            </CommonGrid2>
          ) : (
            "-"
          )}
        </TableCell>
        <CustomizeTableCell textAlign="center">
          {/* {!row.binary_text ? (
            "-"
          ) : ( */}
          <IconButton onClick={() => handleDownload(row)}>
            <CandidateSourcingDownloadIco />
          </IconButton>
          {/* )} */}
        </CustomizeTableCell>
      </>
    );
  };

  const handleCheckExternalRow = (row) => {
    const existing =
      JSON.parse(localStorage.getItem("Candidate Sourcing")) || {};
    setCheckSelected((prev) => {
      const selected = prev.externalSelect.some(
        (item) => item.ResumeID === row.ResumeID,
      );
      let newSelected;

      if (selected) {
        newSelected = prev.externalSelect.filter(
          (item) => item.ResumeID !== row.ResumeID,
        );
      } else {
        newSelected = [...prev.externalSelect, row];
      }
      const checkData = newSelected.map((item) => ({
        ...item,
        file: {
          progress: 1,
          buffer: 1,
          visible: false,
        },
      }));
      const updated = {
        ...existing,
        [jobId]: {
          ...existing[jobId],
          data: checkData,
          status: "process",
        },
      };
      localStorage.setItem("Candidate Sourcing", JSON.stringify(updated));
      dispatch(
        JobCandidateSourcing({
          id: jobId,
          data: updated[jobId].data,
          status: "process",
        }),
      );
      return { ...prev, externalSelect: newSelected };
    });
  };

  const handleDownload = async (row) => {
    let payload = {
      resumes: [{ id: row.ResumeID, source: row.source,name: row.name }],
    };
    const data = await SeachExternalDataBaseRowClick(payload);
    const getData = data?.data?.[0];
     if (!getData?.binary_text || getData?.binary_text === "none") {
      setDialogErrorMessage(
        `The following profile(s) are missing resume documents and cannot be downloaded:\n\n• ${row.name}`
      );
      setSelectDialog({
        open: true,
        disabled: false,
        changeStatusLoading: false,
        cancelLoading: false,
        changeLoading: false,
        value: "Active",
        id: "",
        condition: true,
        allInvalid: true, 
      });
      return;
    }
    const base64Data = getData.binary_text;
    const fileType = getData.document_type?.toLowerCase();
    const fileName = getData.ResumeTitle || `file.${fileType || "pdf"}`;
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length)
      .fill(0)
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    let mimeType = "application/octet-stream";
    if (fileType === "pdf") mimeType = "application/pdf";
    else if (fileType === "docx")
      mimeType =
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document";

    const blob = new Blob([byteArray], { type: mimeType });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
    window.URL.revokeObjectURL(link.href);
  };

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const handleDetails = (i, recordIndex) => {
    setResultData((prev) => {
      return {
        ...prev,
        data: prev.data.map((item, index) => {
          if (index === i) {
            return {
              ...prev.data[index],
              details: item.details === "See More" ? "Hide More" : "See More",
            };
          } else {
            return {
              ...prev.data[index],
            };
          }
        }),
      };
    });
  };

  const handleSerchAgain = async () => {
    const existing =
      JSON.parse(localStorage.getItem("Candidate Sourcing")) || {};
    const updated = {
      ...existing,
      [jobId]: {
        data: [],
        status: "",
      },
    };
    localStorage.setItem("Candidate Sourcing", JSON.stringify(updated));
    dispatch(
      JobCandidateSourcing({
        id: jobId,
        data: updated[jobId].data,
        status: "",
      }),
    );
    setCheckSelected((prev) => ({
      ...prev,
      candidateSelect: [],
      externalSelect: [],
    }));
    setResultData((prev) => {
      return {
        ...prev,
        searhLoading: true,
      };
    });
    await handleFetchCall({ jobId });
    setResultData((prev) => {
      return {
        ...prev,
        searhLoading: false,
      };
    });
  };

  const handleAddToJob = async () => {
    const existing =
      JSON.parse(localStorage.getItem("Candidate Sourcing")) || {};
    let checkData = checkSelected.candidateSelect.map((item) => {
      return {
        ...item,
        result_title: "Candidate Search Results",
        file: {
          progress: 1,
          buffer: 1,
          visible: false,
        },
      };
    });
    const updated = {
      ...existing,
      [jobId]: {
        ...existing[jobId],
        data: checkData,
        status: "Inprogress",
      },
    };

    localStorage.setItem("Candidate Sourcing", JSON.stringify(updated));
    dispatch(
      JobCandidateSourcing({
        id: jobId,
        data: updated[jobId].data,
        status: "Inprogress",
      }),
    );

    const resumeIds = checkSelected?.candidateSelect?.map((item) => item.id);

    try {
      const payload = {
        job: jobId,
        resumes: resumeIds,
      };

      const response = await AddToJobPool(payload);
      const reader = response.body.getReader();
      const decoder = new TextDecoder("utf-8");
      let buffer = "";

      while (true) {
        const { value, done } = await reader.read();
        if (done) break;
        const chunk = decoder.decode(value, { stream: true });
        buffer += chunk;
        let boundaryIndex;
        while ((boundaryIndex = buffer.indexOf("}\n")) !== -1) {
          const jsonString = buffer.slice(0, boundaryIndex + 1);
          buffer = buffer.slice(boundaryIndex + 1);
          const jsonResponse = JSON.parse(jsonString);
          try {
            await processJsonResponse(jsonResponse, "internal");
          } catch (e) {
            let checkData = existing[jobId].map((item) => {
              return {
                ...item,
                file:
                  item.id === jsonResponse.resume_id
                    ? {
                        ...item.file,
                        message: "Error during the request",
                        visible: true,
                      }
                    : item.file,
              };
            });
            const updated = {
              ...existing,
              [jobId]: {
                ...existing[jobId],
                data: checkData,
                status: "fail",
              },
            };

            localStorage.setItem("Candidate Sourcing", JSON.stringify(updated));
            dispatch(
              JobCandidateSourcing({
                id: jobId,
                data: updated[jobId].data,
                status: "fail",
              }),
            );

            setSnackbarState({
              open: true,
              message: "Error parsing JSON",
              severity: "error",
            });
          }
        }
      }

      if (buffer) {
        const jsonResponse = JSON.parse(buffer);
        try {
          await processJsonResponse(jsonResponse, "internal");
        } catch (e) {
          let checkData = existing[jobId].data.map((item) => {
            return {
              ...item,
              file:
                item.id === jsonResponse.resume_id
                  ? {
                      ...item.file,
                      message: "Error during the request",
                      visible: true,
                    }
                  : item.file,
            };
          });
          const updated = {
            ...existing,
            [jobId]: {
              ...existing[jobId],
              data: checkData,
              status: "fail",
            },
          };

          localStorage.setItem("Candidate Sourcing", JSON.stringify(updated));
          dispatch(
            JobCandidateSourcing({
              id: jobId,
              data: updated[jobId].data,
              status: "fail",
            }),
          );
          setSnackbarState({
            open: true,
            message: "Error parsing final JSON chunk",
            severity: "error",
          });
        }
      }
    } catch (error) {
      let checkData = existing[jobId].data.map((item) => {
        return {
          ...item,
          file: {
            ...item.file,
            message: "Error during the request",
            visible: true,
          },
        };
      });
      const updated = {
        ...existing,
        [jobId]: {
          ...existing[jobId],
          data: checkData,
          status: "fail",
        },
      };

      localStorage.setItem("Candidate Sourcing", JSON.stringify(updated));
      dispatch(
        JobCandidateSourcing({
          id: jobId,
          data: updated[jobId].data,
          status: "fail",
        }),
      );

      setSnackbarState({
        open: true,
        message: "Error during the request",
        severity: "error",
      });
    }
  };

  const processJsonResponse = async (jsonResponse, type) => {
    const { success, data, message, resume_id } = jsonResponse;
    if (data && Object?.keys(data)?.length === 0) {
      const existing =
        JSON.parse(localStorage.getItem("Candidate Sourcing")) || {};
      let checkData = existing[jobId].data.map((item) => {
        return {
          ...item,
          file: {
            ...item.file,
            message: message,
            visible: true,
            progress_message: data.progress_message,
          },
        };
      });
      const updated = {
        ...existing,
        [jobId]: {
          ...existing[jobId],
          data: checkData,
          status: "fail",
        },
      };

      localStorage.setItem("Candidate Sourcing", JSON.stringify(updated));
      dispatch(
        JobCandidateSourcing({
          id: jobId,
          data: updated[jobId].data,
          status: "fail",
        }),
      );

      setSnackbarState({
        open: true,
        message: message,
        severity: "error",
      });
    } else if (success && data?.percent !== undefined) {
      const existing =
        JSON.parse(localStorage.getItem("Candidate Sourcing")) || {};
      let checkData = existing[jobId].data.map((item) => {
        return {
          ...item,
          file: (
            type === "internal"
              ? item.id === resume_id
              : item.name === data.current_resume
          )
            ? {
                ...item.file,
                progress: data.percent,
                buffer: data.percent,
                visible: false,
                progress_message: data.progress_message,
              }
            : item.file,
        };
      });
      const updated = {
        ...existing,
        [jobId]: {
          data: checkData,
          status: "Inprogress",
        },
      };
      localStorage.setItem("Candidate Sourcing", JSON.stringify(updated));
      dispatch(
        JobCandidateSourcing({
          id: jobId,
          data: updated[jobId].data,
          status: data.percent === 100 ? "success" : "Inprogress",
        }),
      );
    } else if (data && data?.length !== 0 && data[0]?.id) {
      const existing =
        JSON.parse(localStorage.getItem("Candidate Sourcing")) || {};
      let checkData = existing[jobId].data.map((item) => {
        return {
          ...item,
          file: {
            ...item.file,
            progress: 100,
            buffer: 100,
            visible: false,
          },
        };
      });
      const updated = {
        ...existing,
        [jobId]: {
          data: checkData,
          status: "success",
        },
      };

      dispatch(
        JobCandidateSourcing({
          id: jobId,
          data: updated[jobId].data,
          status: "success",
        }),
      );
      setCheckSelected((prev) => ({
        ...prev,
        candidateSelect: [],
        externalSelect: [],
      }));
      handleFetchCall({ jobId });

      // navigate(
      //   `/jobs/jobs-view?id=${jobId}&title=${query.get("title")}&value=0`
      // );
      // dispatch(
      //   JobCandidateSourcing({
      //     id: jobId,
      //     data: [],
      //     status: "",
      //   })
      // );
    } else if (!success) {
      const existing =
        JSON.parse(localStorage.getItem("Candidate Sourcing")) || {};
      let checkData = existing[jobId].data.map((item) => {
        return {
          ...item,
          file: (
            type === "internal"
              ? item.id === resume_id || data.length === 0
              : item.name === data.current_resume || data.length === 0
          )
            ? { ...item.file, visible: true, message: message }
            : { ...item.file, delete: true },
        };
      });
      const updated = {
        ...existing,
        [jobId]: {
          data: checkData,
          status: "fail",
        },
      };

      localStorage.setItem("Candidate Sourcing", JSON.stringify(updated));
      dispatch(
        JobCandidateSourcing({
          id: jobId,
          data: updated[jobId].data,
          status: "fail",
        }),
      );
    }
  };

  // Core logic to process and stream the upload request
const executeExternalUpload = async (validResumesData) => {
  const existing = JSON.parse(localStorage.getItem("Candidate Sourcing")) || {};
  const formData = new FormData();
  const generatedFiles = [];

  validResumesData.forEach((item) => {
    const base64Data = item.binary_text;
    const fileName = item.id || "file";
    const fileType = item.document_type?.toLowerCase() || "pdf";
    const byteCharacters = atob(base64Data);
    const byteNumbers = Array.from(byteCharacters, (char) => char.charCodeAt(0));
    const byteArray = new Uint8Array(byteNumbers);

    let mimeType = "application/octet-stream";
    if (fileType === "pdf") mimeType = "application/pdf";
    else if (fileType === "docx") {
      mimeType = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      }
      const blob = new Blob([byteArray], { type: mimeType });
      const file = new File([blob], `${fileName}.${fileType}`, { type: mimeType });
    
    generatedFiles.push({ ...item, file });
      formData.append("resume_file", file);
    });
    formData.append("id", jobId);

  // Map back matching selection structures for UI indicator updates
  const buildData = checkSelected.externalSelect
    .filter(item => validResumesData.some(v => v.id === item.ResumeID))
    .map((item, i) => {
      const f = generatedFiles[i];
      return {
        ...item,
        result_title: "External Search Results",
        name: f?.file?.name,
        document_type: f.document_type,
        ResumeID: f.id,
        file: {
          name: f?.file?.name,
          progress: 1,
          buffer: 1,
          visible: false,
        },
      };
    });

    const getUpdated = {
      ...existing,
      [jobId]: {
        ...existing[jobId],
        data: buildData,
        status: "Inprogress",
      },
    };
    localStorage.setItem("Candidate Sourcing", JSON.stringify(getUpdated));
    dispatch(JobCandidateSourcing({ id: jobId, data: getUpdated[jobId].data, status: "Inprogress" }));

    try {
      const response = await UploadJob(formData);
      const reader = response.body.getReader();
      const decoder = new TextDecoder("utf-8");
      let buffer = "";

      while (true) {
        const { value, done } = await reader.read();
        if (done) break;
        const chunk = decoder.decode(value, { stream: true });
        buffer += chunk;
        let boundaryIndex;
        while ((boundaryIndex = buffer.indexOf("}\n")) !== -1) {
          const jsonString = buffer.slice(0, boundaryIndex + 1);
          buffer = buffer.slice(boundaryIndex + 1);
          const jsonResponse = JSON.parse(jsonString);
          try {
            await processJsonResponse(jsonResponse, "external");
          } catch (e) {
          handleUploadError(existing, jsonResponse.current_resume);
        }
      }
    }
    if (buffer) {
      const jsonResponse = JSON.parse(buffer);
      try {
        await processJsonResponse(jsonResponse, "external");
      } catch (e) {
        handleUploadError(existing, jsonResponse.current_resume);
      }
    }
  } catch (error) {
    handleUploadGeneralError(existing);
  }
};

// Extracted error helper block cleanups
const handleUploadError = (existing, currentResume) => {
  let checkData = existing[jobId].map((item) => ({
    ...item,
    file: item.name === currentResume ? { ...item.file, message: "Error during the request", visible: true } : item.file,
  }));
  updateFailedState(existing, checkData);
};

const handleUploadGeneralError = (existing) => {
  let checkData = existing[jobId].data.map((item) => ({
    ...item,
    file: { ...item.file, message: "Error during the request", visible: true },
  }));
  updateFailedState(existing, checkData);
};

const updateFailedState = (existing, checkData) => {
  const updated = { ...existing, [jobId]: { ...existing[jobId], data: checkData, status: "fail" } };
  localStorage.setItem("Candidate Sourcing", JSON.stringify(updated));
  dispatch(JobCandidateSourcing({ id: jobId, data: updated[jobId].data, status: "fail" }));
  setSnackbarState({ open: true, message: "Error parsing JSON payload", severity: "error" });
  setSelectDialog({
        open: true,
        disabled: false,
        changeStatusLoading: false,
        cancelLoading: false,
        changeLoading: false,
        value: "Active",
        id: "",
        condition: true,
      });
};

const handleAddToExternal = async () => {
   setExternalValidating(true);
  let payload = {
    resumes: checkSelected?.externalSelect.map((item) => ({
      id: item.ResumeID,
      source: item.source,
      name: item.name,
    })),
    
  };

  try {
    const getData = await SeachExternalDataBaseRowClick(payload);
    const responses = getData?.data || [];

    const invalidResumes = responses.filter(
      (item) => !item.binary_text || item.binary_text === "none"
    );
    const validResumes = responses.filter(
      (item) => item.binary_text && item.binary_text !== "none"
    );

    if (invalidResumes.length > 0) {
      // Build name list with error from API response directly
      const invalidList = invalidResumes
        .map((r) => `• ${r.name}`)
        .join("\n");

      if (validResumes.length === 0) {
        setDialogErrorMessage(
          `The following profile(s) are missing resume documents and cannot be processed:\n\n${invalidList}`
        );
        setSelectDialog({
          open: true,
          disabled: false,
          changeStatusLoading: false,
          cancelLoading: false,
          changeLoading: false,
          value: "Active",
          id: "",
          condition: true,
          allInvalid: true,
        });
        return;
      }

      setDialogErrorMessage(
        `The following profile(s) are missing resume documents and cannot be processed:\n\n${invalidList}\n\nDo you want to proceed with the remaining valid profile(s)? ${validResumes.length} valid profile(s)?`
      );
      setPendingValidResumes(validResumes);
      setSelectDialog({
        open: true,
        disabled: false,
        changeStatusLoading: false,
        cancelLoading: false,
        changeLoading: false,
        value: "Active",
        id: "",
        condition: true,
        allInvalid: false,   // <-- shows Proceed button
      });
    } else {
      await executeExternalUpload(validResumes);
    }
  } catch (error) {
    setSnackbarState({
      open: true,
      message: "An error occurred while inspecting remote candidate records.",
      severity: "error",
    });
  }
  finally {    setExternalValidating(false);
  }
};

const handleProceedWithRemaining = async () => {
  const resumesToProcess = [...pendingValidResumes];
  
  // Clear states and shut down open window frames
  setPendingValidResumes([]);
  setSelectDialog((prev) => ({ ...prev, open: false }));

  // Initiate stream pipeline
  await executeExternalUpload(resumesToProcess);
};
  const handlePageChange = (page) => {
    setResultData((prev) => ({
      ...prev,
      data:
        prev.data.map((item, index) => {
          if (index === 0) {
            return {
              ...prev.data[index],
              currentPage: page,
            };
          } else {
            return {
              ...prev.data[index],
            };
          }
        }) || [],
    }));
    handleFetchCall({ jobId, page });
  };
  
// StatusFooter in CandidateScoring.jsx
const StatusFooter = () => (
  <CommonGrid2
    display="flex"
    justifyContent="center"
    gap="1rem"
    marginTop="1.5rem"
    width="100%"
  >
    <CommonButton
      value={statusDialog.allInvalid ? "Close" : "Cancel"}
      variant="outlined"
      borderColor="#D0D5DD"
      color="#344054"
      fontWeight="700"
      padding={"10px 0"}
      width="100%"
      onClick={handleChangeStatusClose}
    />
    {!statusDialog.allInvalid && (
      <CommonButton
        value="Proceed"
        variant="contained"
        background="#7F56D9"
        fontWeight="700"
        padding={"10px 0"}
        width="100%"
        onClick={handleProceedWithRemaining}
      />
    )}
  </CommonGrid2>
);

  const handleDropdownChange = (e) => {
    console.log(e.target.value, " e.target.value");
    setResultData((prev) => ({
      ...prev,
      data:
        prev.data.map((item, index) => {
          if (index === 0) {
            return {
              ...prev.data[index],
              sort_data_value: e.target.value,
            };
          } else {
            return {
              ...prev.data[index],
            };
          }
        }) || [],
    }));
    handleFetchCall({ jobId, sort_mode: e.target.value?.value });
  };

  const CustomMenuItem = (item, index) => (
    <MenuItem value={item} key={index} name={item?.name}>
      {item?.name}
    </MenuItem>
  );

  return (
    <CustomDiv
      margin={"1rem 1rem 1rem 1.5rem"}
      padding={"1rem"}
      borderRadius={"10px"}
      background="#fff"
      border={"1px solid rgba(0, 0, 0, 0.12)"}
    >
      <TabContext value={tabValue}>
        {resultData.loading ? (
          <HandleSkeletion height={50} width={"60%"} />
        ) : (
          <Breadcrumbs breadCrumbData={breadCrumbData} />
        )}

        <CommonGrid2
          container
          spacing={2}
          alignItems="center"
          marginTop={"2rem"}
          justifyContent={"space-between"}
        >
          <CommonGrid2
            display={"flex"}
            flexDirection={"column"}
            gap={"8px"}
            size={{ xs: 12, md: 7, sm: 12 }}
          >
            {resultData.loading ? (
              <HandleSkeletion height={70} width={"50%"} />
            ) : (
              <Typography variant="h3" fontWeight={700}>
                {query.get("title")}
              </Typography>
            )}
            {resultData.loading ? (
              <HandleSkeletion height={50} width={"40%"} />
            ) : (
              <Typography variant="h6">{resultData.company_name}</Typography>
            )}
          </CommonGrid2>
          <CommonGrid2
            size={{ xs: 12, md: 5, sm: 12 }}
            container
            spacing={2}
            gap={"10px"}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"end"}
          >
            {resultData.loading ? (
              <HandleSkeletion height={50} width={"50%"} />
            ) : (
              <Fragment>
                <CommonButton
                  value={"Back"}
                  startIcon={<BackArrowIco />}
                  gap={"0px"}
                  variant="outlined"
                  color="#344054"
                  padding={"8px 1.5rem"}
                  fontWeight={"700"}
                  fontSize={"15px"}
                  border={"#D0D5DD"}
                  width="auto"
                  customStyle={{
                    "&:hover svg path": {
                      stroke: "#fff",
                    },
                  }}
                  onClick={handleBackClick}
                />

                <TabViewSection
                  onChange={handleTabChange}
                  variant="scrollable"
                  scrollButtons="auto"
                  aria-label="visible arrows tabs example"
                  customStyle={{
                    background: "#F9FAFB !important",
                    padding: "5px",
                    borderRadius: "8px",
                    "& .MuiTab-root": {
                      minHeight: "34px",
                      padding: "6px 2rem",
                      fontWeight: 700,
                    },
                    "& .Mui-selected": {
                      background: "#7F56D9 !important",
                      margin: "0px",
                      color: "#fff !important",
                      boxShadow: "0px 0px 1px 0px #101828",
                      borderRadius: "5px",
                    },
                  }}
                >
                  {tabData.map((item, index) => (
                    <Tab label={item} value={index} disabled />
                  ))}
                </TabViewSection>
              </Fragment>
            )}
          </CommonGrid2>
        </CommonGrid2>
        {processConditionCheck && (
          <CandidateProgress
            checkSelected={candidateSourcing[jobId].data}
            handleSerchAgain={handleSerchAgain}
            handleAddToJob={handleAddToJob}
            candidateSourcing={candidateSourcing}
            jobId={jobId}
          />
        )}
        <Fragment>
          {tabValue === 0 && (
            <Fragment>
              <CandidateResult
                resultData={resultData}
                handleSerchAgain={handleSerchAgain}
                handleHubTableBodyData={handleHubTableBodyData}
                handleSearchTableBodyData={handleSearchTableBodyData}
                handleDetails={handleDetails}
                handleAddToJob={handleAddToJob}
                checkSelected={checkSelected}
                handleAddToExternal={handleAddToExternal}
                processConditionCheck={
                  candidateSourcing[jobId] &&
                  candidateSourcing[jobId].data.length !== 0 &&
                  candidateSourcing[jobId].status === "fail"
                    ? false
                    : candidateSourcing[jobId] &&
                      candidateSourcing[jobId].data.length !== 0 &&
                      candidateSourcing[jobId].status !== "process"
                }
                handlePageChange={handlePageChange}
                handleDropdownChange={handleDropdownChange}
                CustomMenuItem={CustomMenuItem}
                externalValidating={externalValidating}
              />
            </Fragment>
          )}
          {tabValue === 1 && (
            <CommonGrid2
              display={"flex"}
              justifyContent={"space-between"}
              gap={"8px"}
              marginTop={"2rem"}
              flexDirection={"column"}
            >
              <Typography variant="h3" fontWeight={700}>
                {"Deep Candidate Sourcing"}
              </Typography>
              <CommonGrid2
                marginTop={"10px"}
                display={"flex"}
                background="#FFFAE3"
                padding={"0.8rem"}
                borderRadius={"10px"}
                gap={"0.8rem"}
                alignItems={"center"}
              >
                <CandidateWarningIco />
                <Typography variant="p">
                  Your prompt will not affect the skills of the Boolean string.
                  To do so edit skills in the Job Page.
                </Typography>
              </CommonGrid2>
              <CommonGrid2 container spacing={3} marginTop={"0.8rem"}>
                {/* {chatBotData.loader && (
                    <CustomDiv>
                      <WholePageEllipse>
                        <Ellipse />
                      </WholePageEllipse>
                      <WholePageOpacity></WholePageOpacity>
                    </CustomDiv>
                  )} */}
                <CommonGrid2 item size={6}>
                  <Typography variant="p">Search Strategy</Typography>
                  <CustomDiv position="relative" margin="10px 0px 0px">
                    <CommonTextField
                      rows={7}
                      multiline
                      padding={"0px"}
                      backgroundColor={"#F7F8F9"}
                      border={"1px solid #EAECF0"}
                      customStyle={{
                        "& .MuiInputBase-root": {
                          paddingBottom: "5rem",
                        },
                      }}
                      // value={data}
                      // onChange={(e) => {
                      //   setData(e.target.value);
                      //   if (debounceTimer.current) {
                      //     clearTimeout(debounceTimer.current);
                      //   }
                      //   debounceTimer.current = setTimeout(() => {
                      //     setFieldValue("candidate_fit_summary", e.target.value);
                      //   }, 500);
                      // }}
                    />

                    <CommonTextField
                      border={"1px solid #EAECF0"}
                      padding={"15px 15px 15px 10px"}
                      paddingRight={5}
                      backgroundColor={"#EBF1F4"}
                      placeholder={"Tell us about your ideal candidate"}
                      placeholderFontSize={"14px"}
                      // value={chatBotData.value}
                      // onChange={(event) => handleChatBotChange(event, setFieldValue)}
                      // disabled={chatBotData.loader || loading}
                      datePickerCalender={true}
                      calenderIcon={<ChatBotInputIco color="#7F56D9" />}
                      customStyle={{
                        position: "absolute",
                        right: 0,
                        bottom: 0,
                        padding: "1rem",
                      }}
                    />
                  </CustomDiv>
                </CommonGrid2>
                <CommonGrid2 item size={6}>
                  <Typography variant="p">Boolean String</Typography>
                  <CustomDiv position="relative" margin="10px 0px 0px">
                    <CommonTextField
                      rows={7}
                      multiline
                      padding={"0px"}
                      customStyle={{
                        "& .MuiInputBase-root": {
                          paddingBottom: "4rem",
                        },
                      }}
                    />
                    <CommonButton
                      value={"Search"}
                      customStyle={{
                        position: "absolute",
                        right: 0,
                        bottom: 0,
                        margin: "1rem",
                      }}
                    />
                  </CustomDiv>
                </CommonGrid2>
              </CommonGrid2>
            </CommonGrid2>
          )}
        </Fragment>
      </TabContext>
      <DialogCandidateHub
  open={statusDialog.open}
  handleButttonClose={handleChangeStatusClose}
  handleClose={handleChangeStatusClose}
  footer={<StatusFooter />}
  title={"Resume Document Missing"}
  content={dialogErrorMessage}   
  titlepadding={"1rem 0px 0px"}
  minWidth="400px"
/>

      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />
    </CustomDiv>
  );
}
